import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Flex, FlexColumn } from '@/@bothrs-ui/web/components/layout/index'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { mixpanel } from '@/mixpanel'
import { navigateMaps } from '@/modules/shared/helpers/navigation'
import { StCard } from './RouteCard.styled'

type Props = {
  address: string
}

export const RouteCard = ({ address }: Props) => {
  const theme = useTheme()

  const handleClick = () => {
    if (navigateMaps(address)) {
      mixpanel.track('home_feed_navigation')
    }
  }

  return address ? (
    <StCard alignItems={'center'} onClick={handleClick}>
      <Flex justifyContent={'center'}>
        <img src='/img/svg/map-pin.svg' alt='Map Pin' />
      </Flex>
      <FlexColumn justifyContent={'center'}>
        <H4 color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'home.route-card.title',
            comment: 'route to your appointment title',
            message: 'Vlot je locatie bereiken?',
          })}
        </H4>
        <Flex alignItems='flex-end' justifyContent='space-between'>
          <Span type='BodyMediumRegular' color={theme.Components.Card.Text}>
            {t({
              id: 'home.route-card.message',
              comment: 'route to your appointment message',
              message: 'Ontdek de vlotste route naar je afspraak.',
            })}
          </Span>
          <FontAwesomeIcon icon={['far', 'chevron-right']} fontSize={16} />
        </Flex>
      </FlexColumn>
    </StCard>
  ) : null
}
